// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__HA8Ku","spin-360":"NotFound_spin-360__1Mtz2"};